// SignalResponse shape:
//   { answerSDP: string, gameID: number }   // uint64 fits exactly up to 2^53

export async function doSignalingHandshake() {
  const pc = new RTCPeerConnection({})
  const dc = pc.createDataChannel('game', { ordered: false, maxRetransmits: 0 })
  dc.binaryType = 'arraybuffer'

  const offer = await pc.createOffer()
  await pc.setLocalDescription(offer)
  await iceGatheringComplete(pc)

  // Iter 1.12: forward `launch_token` from the page URL to the Gateway's
  // signaling endpoint so headless-test browser launches can be correlated
  // with the assigned GameID. Empty/absent on regular human launches.
  const pageQuery = new URLSearchParams(window.location.search)
  const launchToken = pageQuery.get('launch_token') ?? ''
  const signalURL = launchToken
    ? `/signal?launch_token=${encodeURIComponent(launchToken)}`
    : '/signal'

  const r = await fetch(signalURL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ offerSDP: pc.localDescription.sdp }),
  })
  if (!r.ok) throw new Error(`signaling failed: ${r.status} ${await r.text()}`)
  const resp = await r.json()
  await pc.setRemoteDescription({ type: 'answer', sdp: resp.answerSDP })
  return { pc, dc, resp }
}

function iceGatheringComplete(pc) {
  return new Promise((resolve) => {
    if (pc.iceGatheringState === 'complete') {
      resolve()
      return
    }
    const onChange = () => {
      if (pc.iceGatheringState === 'complete') {
        pc.removeEventListener('icegatheringstatechange', onChange)
        resolve()
      }
    }
    pc.addEventListener('icegatheringstatechange', onChange)
    setTimeout(() => {
      pc.removeEventListener('icegatheringstatechange', onChange)
      resolve()
    }, 3000)
  })
}
